/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/index' // 首页
import gg from '@/page/gg/gg' // 公告页面
import wz from '@/page/wz/wz' // 文章页面
import tzzjy from '@/page/tzzjy/tzzjy' // 投资者教育页面
import lxts from '@/page/lxts/lxts' // 投诉建议—联系我们
import yjfk from '@/page/yjfk/yjfk' // 意见反馈页面
import xxgs from '@/page/xxgs/xxgs' // 信息公示
import cjwt from '@/page/cjwt/cjwt' // 常见问题
import qhkh from '@/page/qhkh/qhkh' // 期货开户
import zcgl from '@/page/zcgl/zcgl' // 资产管理
import jjgk from '@/page/zcgl/page/jjgk' // 基金概况
import zkqq from '@/page/zkqq' // 掌控全球
import lhsx from '@/page/lhsx' // 靓号随行
import appxz from '@/page/appxz' // 靓号随行
import bdyxgg from '@/page/bdyxgg' // 百度营销广告
import dy from '@/page/dy'
import livepoint from '@/page/livepoint'
import openAccount from '@/page/openAccount'
import NewSimulate from '@/page/simulate/NewSimulate'
import download from '@/page/openAccount/download'

import QhRecommendOpenAccount from '@/page/qhRecommendOpenAccount'
import QhDownload from '@/page/qhRecommendOpenAccount/download'
import jbmzlsq from '@/page/jbmzlsq' // 基本面资料索取

import Tecentadvertisement from '@/page/lhsx/TecentAdvertisement' // 腾讯广告
import xczx from '@/page/xczx' // 乡村振兴
import xczxResult from '@/page/xczx/result' // 乡村振兴

import wjdc from '@/page/wjdc' //问卷调研
import dhqhystk from '@/page/ystk/dhqh'
import dhjrystk from '@/page/ystk/dhjr'
import dsfxxgxqd from '@/page/dsfxxgxqd/index'//第三方信息共享清单
import grxxsjqd from '@/page/grxxsjqd/index'//个人信息收集清单


import dxdy from '@/page/dxdy/dxdy'//短信订阅退订
import xzlj from '@/page/xzlj/xzlj'//下载app
import sendPoints from '@/page/sendPoints/index'//

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    }, {
      path: '/gg/:nr',
      name: 'gg',
      component: gg
    }, {
      path: '/tzzjy/:nr',
      name: 'tzzjy',
      component: tzzjy
    }, {
      path: '/wz/:ret/:nr',
      name: 'wz',
      component: wz
    }, {
      path: '/lxts/:nr',
      name: 'lxts',
      component: lxts
    }, {
      path: '/yjfk',
      name: 'yjfk',
      component: yjfk
    }, {
      path: '/xxgs/:nr',
      name: 'xxgs',
      component: xxgs
    }, {
      path: '/cjwt',
      name: 'cjwt',
      component: cjwt
    }, {
      path: '/qhkh',
      name: 'qhkh',
      component: qhkh
    }, {
      path: '/zcgl/:nr',
      name: 'zcgl',
      component: zcgl,
      children: [
        {
          path: 'jjgk/:id',
          name: 'jjgk',
          component: jjgk,
          meta: { showjjgk: true }
        }
      ]
    }, {
      path: '/zkqq',
      name: 'zkqq',
      component: zkqq
    },
    {
      path: '/lhhd',
      name: 'lhhd',
      component: lhsx
    },
    {
      path: '/lhsx',
      name: 'lhsx',
      component: lhsx
    },
    {
      path: '/appxz',
      name: 'appxz',
      component: appxz
    },
    {
      path: '/txgg',
      name: 'tecentadvertisement',
      component: Tecentadvertisement
    },
    {
      path: '/hd',
      name: 'hd',
      component: dy
    },
    {
      path: '/openAccount',
      name: 'openAccount',
      component: openAccount
    },
    // {
    //   path: '/simulate',
    //   name: 'NewSimulate',
    //   component: NewSimulate
    // },

    {
      path: '/livepoint',
      name: 'livepoint',
      component: livepoint
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/qhrecommendopenaccount',
      name: 'QhRecommendOpenAccount',
      component: QhRecommendOpenAccount
    },
    {
      path: '/qhdownload',
      name: 'QhDownload',
      component: QhDownload
    },
    {
      path: '/jbmzlsq',
      name: 'jbmzlsq',
      component: jbmzlsq
    },
    {
      path: '/bdyxgg',
      name: 'bdyxgg',
      component: bdyxgg
    },
    {
      path: '/xczx',
      name: 'xczx',
      component: xczx
    },
    {
      path: '/xczxResult',
      name: 'xczxResult',
      component: xczxResult
    },

    {
      path: '/wjdc',
      name: 'wjdc',
      component: wjdc
    },
    {
      path: '/dhqhystk',
      name: 'dhqhystk',
      component: dhqhystk
    },
    {
      path: '/dhjrystk',
      name: 'dhjrystk',
      component: dhjrystk
    },
    {
      path: '/dsfxxgxqd',
      name: 'dsfxxgxqd',
      component: dsfxxgxqd
    },
    {
      path: '/grxxsjqd',
      name: 'grxxsjqd',
      component: grxxsjqd
    },
    {
      path: '/dxdy',
      name: 'dxdy',
      component: dxdy
    },
    {
      path: '/xzlj',
      name: 'xzlj',
      component: xzlj
    },
    {
      path: '/sendPoints',
      name: 'sendPoints',
      component: sendPoints
    },

    { path: '*', redirect: '/' }
  ]
})
router.afterEach(() => {
  // 路由结束完关闭边侧栏
  $('#dh-OffCanvas').offCanvas('close')
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js